module.exports = __webpack_public_path__ + "assets/media/lunch.b3a7f8f7.mp3";